import {
    FETCH_WEIGHT_LIST,
    FETCH_WEIGHT_LIST_FETCHING,
    FETCH_WEIGHT_LIST_SUCCESS,
    FETCH_WEIGHT_LIST_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    weightList: [],
    isWeightListFetching: false,
    didWeightListFetchFail: false
};

// ======= Fetching Handlers =======
const fetchWeightListFetching = (state, action) => {
    return {
        weightList: [...state.weightList],
        isWeightListFetching: true,
        didWeightListFetchFail: false
    };
};

const fetchWeightListSuccess = (state, action) => {
    const oldWeightList = state.weightList;
    const newWeightList = action.weightList.dateWeightList;

    let weightList;

    // If there's already weight data in the store, blend the new and old data together, else add all of the new data
    // This way you can request any daily weigh-in data with varying time frames and have it all stored together for pagination
    if (oldWeightList.length > 0) {
        let blendedList = [...oldWeightList, ...newWeightList];
        let filteredList = removeDuplicates(blendedList, 'calendarDate');
        let sortedList = sortByCalendarDate(filteredList);

        weightList = sortedList;
    } else {
        weightList = newWeightList;
    }

    return {
        weightList,
        isWeightListFetching: false,
        didWeightListFetchFail: false
    };
};

const fetchWeightListFail = (state, action) => {
    return {
        weightList: [...state.weightList.weightList],
        isWeightListFetching: false,
        didWeightListFetchFail: true
    };
};

// Remove duplicates that have the same value on the provided object key
const removeDuplicates = (originalArray, objKey) => {
    let trimmedArray = [];
    let values = [];
    let value;

    for (let i = 0, len = originalArray.length; i < len; i++) {
        value = originalArray[i][objKey];

        if (values.indexOf(value) === -1) {
            trimmedArray.push(originalArray[i]);
            values.push(value);
        }
    }

    return trimmedArray;
};

const sortByCalendarDate = (arrayToSort) => {
    let sortedArray = arrayToSort.sort((a, b) => {
        return new Date(a.calendarDate) - new Date(b.calendarDate);
    });

    return sortedArray;
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_WEIGHT_LIST_FETCHING]: fetchWeightListFetching,
    [FETCH_WEIGHT_LIST_SUCCESS]: fetchWeightListSuccess,
    [FETCH_WEIGHT_LIST_FAIL]: fetchWeightListFail
};

// ======= Default Action =======
export default function weightList(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchWeightList(startDate, endDate, evictCache) {
    return {
        type: FETCH_WEIGHT_LIST,
        startDate: startDate,
        endDate: endDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getWeightList = (state) => {
    return state.weightList.weightList ? state.weightList.weightList : [];
};

export const isWeightListFetching = (state) => {
    return state.weightList.isWeightListFetching;
};

export const didWeightListFetchFail = (state) => {
    return state.weightList.didWeightListFetchFail;
};
